import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';
const CONTACT_US = 'https://www.mountrainiermd.org/contactus';
const YOUTUBE = 'https://www.youtube.com/mrtvmaryland';
const FACEBOOK = 'https://www.facebook.com/cityofmountrainier';
const TWITTER_X = 'https://www.x.com/cityofmtrainier';
const INSTAGRAM = 'https://www.instagram.com/cityofmountrainier';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={YOUTUBE}>
            YouTube
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={FACEBOOK}>
            Facebook
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={TWITTER_X}>
            X
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={INSTAGRAM}>
            Instagram
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
